import script from "./AIPromptHome.vue?vue&type=script&setup=true&lang=js"
export * from "./AIPromptHome.vue?vue&type=script&setup=true&lang=js"

import "./AIPromptHome.vue?vue&type=style&index=0&id=7614b857&lang=less"

const __exports__ = script;

export default __exports__